import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { systemFlow, volumes } from '../../data/content';

/** The six core volumes, as text. */
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-130" data-mp="7z3qp4i3mp0w">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="vofzw4dfex37">
        <SectionHeading id="volumes-heading" title={<>
              Votre système complet de <Accent data-id="element-133" data-mp="10q5bbl4k9crt">formation en maquillage.</Accent>
            </>} body="6 volumes conçus pour accompagner tout votre processus pédagogique." data-id="element-132" data-mp="vphmn63t180r" />

        <ol className="mt-12 rounded-[20px] bg-white px-6 shadow-[0_30px_60px_-44px_rgba(59,27,87,0.5)] sm:px-8" role="list" data-id="element-134" data-mp="qwwu07wmx0yt">
          {volumes.map(volume => <li key={volume.number} className="grid gap-1.5 border-b border-brand-charcoal/10 py-5 last:border-b-0 sm:grid-cols-[120px_1fr_auto] sm:items-center sm:gap-6" data-id="element-135" data-mp="1jf29i032wpfb">
              <p className="font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-136" data-mp="7my5xeuq3bq0">
                Volume {volume.number}
              </p>
              <h3 className="font-display text-[1.35rem] font-bold leading-snug text-brand-charcoal sm:text-[1.5rem]" data-id="element-137" data-mp="hkmb6ypyg1mf">
                {volume.title}
              </h3>
              <p className="w-fit rounded-full bg-brand-lavender px-3 py-1 font-body text-[11px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-138" data-mp="vdu36rhy6z4n">
                {volume.stage}
              </p>
            </li>)}
        </ol>

        <TeachingFlow steps={systemFlow} className="mt-8" data-id="element-139" data-mp="10ac5zltpwnec" />

        <CtaBlock label="Oui, je veux gagner du temps" className="mt-12" data-id="element-140" data-mp="108r75k0deiao" />
      </div>
    </section>;
}